import { useContext } from 'react'

import { LoadingStateContext } from '@/providers/LoadingContext'

/**
 * Hook to access the LoadingStateContext.
 * Throws an error if used outside of GlobalLoadingProvider.
 */
export function useLoading() {
  const context = useContext(LoadingStateContext)
  if (context === undefined) {
    throw new Error('useLoading must be used within a GlobalLoadingProvider')
  }

  return context
}
